"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
let ExpandablePanelCollectionService = class ExpandablePanelCollectionService {
    constructor() {
        this._panels = new Array();
    }
    get(panelId) {
        return this._panels.find(p => p.id === panelId);
    }
    add(panel) {
        if (!this.get(panel.id)) {
            this._panels.push(panel);
        }
    }
    remove(panel) {
        let idx = this._panels.findIndex(p => p.id === panel.id);
        if (idx >= 0) {
            this._panels.splice(idx, 1);
        }
    }
};
ExpandablePanelCollectionService = __decorate([
    core_1.Injectable()
], ExpandablePanelCollectionService);
exports.ExpandablePanelCollectionService = ExpandablePanelCollectionService;
